const VALIDATION_FAILED = "Validation Failed";

// Turns an axios error into a user-facing message. Validation failures include
// per-field details, e.g.
// { message: "Validation Failed", details: [{ reference: "\"reference\" length must be ..." }] }
export function apiErrorMessage(error) {
  if (!error.response || !error.response.data) {
    return error.message;
  }

  const { message, details } = error.response.data;

  if (message !== VALIDATION_FAILED || !Array.isArray(details)) {
    return message || error.message;
  }

  const detailMessages = details
    .reduce((messages, detail) => messages.concat(Object.values(detail)), [])
    .map(humaniseDetail);

  return detailMessages.length
    ? `${message}: ${detailMessages.join("; ")}`
    : message;
}

function humaniseDetail(detail) {
  // Joi wraps the field name in quotes, e.g. "reference" length must be...
  const unquoted = detail.replace(/^"([^"]+)"/, "$1");
  return unquoted.charAt(0).toUpperCase() + unquoted.slice(1);
}
